import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { endHandoffEager } from '@/lib/staticHandoff';

interface PageTransitionProps {
  children: React.ReactNode;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  const [displayLocation, setDisplayLocation] = useState(location);

  useEffect(() => {
    if (location !== displayLocation) {
      endHandoffEager();
      setIsVisible(false);
      const timer = setTimeout(() => {
        setDisplayLocation(location);
        setIsVisible(true);
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [location, displayLocation]);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div
      className={`transition-[opacity,transform] duration-300 ease-[cubic-bezier(0.23,1,0.32,1)] ${
        // No transform at rest (2026-10-06): even translate-y-0 is a transform,
        // which makes this wrapper the containing block for every
        // position:fixed descendant — the WhatsApp and back-to-top buttons
        // inside PremiumLayout sat at the bottom of the page instead of
        // floating on screen.
        isVisible
          ? 'opacity-100'
          : 'opacity-0 translate-y-4'
      }`}
    >
      {children}
    </div>
  );
};

export default PageTransition;
